
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from '@apollo/client';
import {
    Loader,
    Icon,
    Button,
    Header,
} from 'semantic-ui-react'

import { PATHS } from '../../../../paths';
import { formatDateTime } from "../../../../dates";
import { JoyyaHeader } from '../../../../components/JoyyaHeader';
import { Session } from '../../../../components/Session';
/* import { ThemeToggle } from '../../../../components/ThemeToggle';
 *             <ThemeToggle />
 *  */
import { GET_COURSE } from '../data/GET_COURSE';

import styles from './TeacherClassView.module.css';

const TeacherClassView = () => {
    let navigate = useNavigate();
    let { id } = useParams();

    const { loading, error, data, refetch } = useQuery(GET_COURSE, { variables: { courseId: Number(id) } });

    const [activeId, setActiveId] = useState();

    const TenHoursAgo = Number(new Date()) - 10 * 60 * 60 * 1000;

    useEffect(() => {
        if (!activeId && !loading && !error && data != null && data.course) {
            const nextSession = data.course.sessions.find(
                (s: { startTime: number, reasonForCancellation: string | null }) =>
                    s.startTime > TenHoursAgo
                    && (s.reasonForCancellation == null || s.reasonForCancellation === ""))

            setActiveId(nextSession?.id)
        }
    }, [loading, error, data, activeId])

    const showError = loading || error || !data || !data.course;

    if (showError) {
        return (
            <>
                <JoyyaHeader />
                <div className='mobile-frame'>
                    <Icon name='arrow left' size='large' className={styles.pointer} onClick={() => navigate(-1)} />
                    {loading && (<Loader inverted content='Loading' />)}
                    {!loading && error && error.message === 'Failed to fetch' && 'No internet connection'}
                    {!loading && !error && !data && 'Class not found'}
                    {!loading && !error && data && !data.course && 'Class not found'}
                </div>
            </>
        )
    }

    if (error) {
        return <div />
    }

    const activeSession = data.course.sessions.find((s: { id: any }) => s.id === activeId)

    // Split the sessions into past and future
    const notCancelled = (s: { reasonForCancellation: string | null }) => s.reasonForCancellation == null 

    const pastSessions = data.course.sessions.filter(notCancelled).filter((s: { startTime: number }) => s.startTime <= new Date().getTime());
    const futureSessions = data.course.sessions.filter(notCancelled).filter((s: { startTime: number }) => s.startTime > new Date().getTime());

    return (
        <>
            <JoyyaHeader />
            <div className='mobile-frame'>
                <Header as='h2'>
                    <span className={styles.header}>
                        <Icon name='arrow left' className={styles.pointer} onClick={() => navigate(-1)} />
                        Sessions
                    </span>
                </Header>
                {data?.course?.classRecords != null && data?.course?.classRecords?.length > 0 && (
                  <>
                <Button
                    onClick={() => {
                        navigate(`${PATHS.CLASSES}/${id}/records`)
                    }}
                >
                    Edit class records
                </Button>
                  <hr />
                  </>
                )}

                {/* Get active session details in place */}
                <div style={{ marginTop: '1em', marginBottom: '0.5em', fontWeight: 'bold' }}>
                    {formatDateTime(activeSession?.startTime)}
                </div>

                <Session canEditCourse={data && data.course && data.course.canEdit} session={activeSession as any} refetchCourse={() => refetch({ variables: { courseId: Number(id) } })} />

                <Header as='h2'>
                    <span className={styles.header}>Upcoming</span>
                </Header>
                {futureSessions.length === 0 && (<div style={{ fontStyle: 'italic', color: 'gray' }}>No upcoming sessions</div>)}
                {futureSessions.map((s: { id: any, startTime: number, attendanceCount: number }) => (
                    <div key={s.id} className={styles.sessionItem} onClick={() => setActiveId(s.id)}
                        style={s.id === activeId ? { backgroundColor: '#d3d3d3' } : {}}

                    >
                        <div>
                            {formatDateTime(s.startTime)}
                        </div>
                        <div>
                            {s.attendanceCount} present
                        </div>
                    </div>
                ))}

                <Header as='h2'>
                    <span className={styles.header}>Past</span>
                </Header>
                {pastSessions.length === 0 && (<div style={{ fontStyle: 'italic', color: 'gray' }}>No past sessions</div>)}
                {pastSessions.reverse().map((s: { id: any, startTime: number, attendanceCount: number }) => (
                    <div key={s.id} className={styles.sessionItem} onClick={() => setActiveId(s.id)}
                        style={s.id === activeId ? { backgroundColor: '#d3d3d3' } : {}}
                    >
                        <div>
                            {formatDateTime(s.startTime)}
                        </div>
                        <div>
                            {s.attendanceCount} present
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { TeacherClassView }
